export const NEWSLETTER_KEY = {
  EMAIL: 'email',
  FIRST_NAME: 'firstName',
  BOT_CHECKER: 'phoneEz'
}

export const NEWSLETTER_SUBMIT_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
}
